export function getResultsHtml(html) {
    // Hash seems to not be there all the time
    // Sometimes it's a URL parameter instead
    const isOffice = window.location.hash.includes('offices') || new URLSearchParams(window.location.search).get('tab') === 'offices';
    const isPeople = window.location.hash.includes('people') || new URLSearchParams(window.location.search).get('tab') === 'people';

    if (html && (isOffice || isPeople)) {
        let newHtml = html;
        const resultsSelector = isOffice
            ? '.office-list .js-filters-results'
            : '.people-list.js-filters-results'

        const parser = new DOMParser();
        const responseDoc = parser.parseFromString(newHtml, "text/html");
        const resultsEl = responseDoc?.querySelector(resultsSelector);

        if (resultsEl) {
            return resultsEl.innerHTML;
        }
    }

    return html
}

export function addAjaxToUrl(url) {
    const urlObj = new URL(url);
    const urlParams = new URLSearchParams(urlObj.search);
    urlParams.set('ajax', true);
    urlObj.search = urlParams.toString()
    return urlObj.toString();
}